export default {
    API_GATEWAY_URL: 'https://tt5ahujwjl.execute-api.eu-west-1.amazonaws.com/prod'
}